import { axiosInstance } from "@/lib/axios-instance";

export type PlanTier = "free" | "plus" | "pro" | "elite";
export type PlanCadenceId =
  | "monthly"
  | "quarterly"
  | "semi-annual"
  | "annual";

export interface PlanCadence {
  id: PlanCadenceId;
  price_id: string;
  amount_cents: number;
  currency: string;
  interval: string | undefined;
  interval_count: number | undefined;
}

export interface Plan {
  tier: PlanTier;
  name: string;
  popular: boolean;
  features: string[];
  /** `null` means unlimited / unspecified. */
  caps: {
    workspaces: number | null;
    premium_deals: number | null;
    storage_mb_per_deal: number | null;
  };
  cadences: PlanCadence[];
}

export interface AddOn {
  pack_size: number;
  price_id: string;
  unit_amount_cents: number;
  currency: string;
  per_credit_cents: number;
}

export const plansApi = {
  async listPlans(): Promise<Plan[]> {
    const response = await axiosInstance.get(`/api/billing/plans`);
    return response.data.result ?? [];
  },

  async listAddOns(): Promise<AddOn[]> {
    const response = await axiosInstance.get(`/api/billing/add-ons`);
    return response.data.result ?? [];
  },
};
